import React from 'react';
import TextInput from '@grnhse/seedling/lib/birch/components/forms/text_input';
import FieldObject from './field_object';
import { withLocalePrefix } from 'shared/utils/translation';
import styled from 'styled-components';
import { CompactRow } from '@grnhse/seedling/lib/birch/layouts/compact_row';

const t = withLocalePrefix('talent_search.form.sections.candidate.labels');

type Props = {
  fieldObject: FieldObject;
  onUpdate: (val: FieldObject) => void;
};

const NumberRow = styled(CompactRow)`
  &&&& {
    flex-wrap: inherit;
  }
`;

const NumberOption = ({ fieldObject, onUpdate }: Props) => {
  const fieldLabel = fieldObject.fieldLabel();
  const rangeMin = (fieldObject.min as string) || undefined;
  const rangeMax = (fieldObject.max as string) || undefined;

  const onRangeMinChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    fieldObject.setMin(e.target.value);
    onUpdate(fieldObject);
  };

  const onRangeMaxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    fieldObject.setMax(e.target.value);
    onUpdate(fieldObject);
  };

  return (
    <NumberRow>
      <TextInput
        label={t('from')}
        id={`${fieldLabel}_${fieldObject.reactKey}_start`}
        value={rangeMin}
        onChange={onRangeMinChange}
        type="number"
      />
      <TextInput
        label={t('to')}
        id={`${fieldLabel}_${fieldObject.reactKey}_end`}
        value={rangeMax}
        onChange={onRangeMaxChange}
        type="number"
      />
    </NumberRow>
  );
};

export default NumberOption;
